import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getCreateKanbanTaskError() {
      return getState().error;
    },
    isCreateKanbanTaskRequestFailure() {
      return getState().request.isFailure;
    },
    isCreateKanbanTaskRequestPending() {
      return getState().request.isPending;
    },
    isCreateKanbanTaskRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
